// 個別機能訓練に関する記録用モジュール.
import * as KirokuConst from '../constants/Kiroku';
import { getCurrentTime } from '../utils/dateUtil';

module KirokuUtil {
  export function addNewHistory(self: any, filteredTraining: KirokuConst.Training[]): void {
    // 新規追加(ローカルに追加、サーバーにはまだ)
    const params: KirokuConst.Training = {
      datetime: getCurrentTime().full,
      datetimeT: getCurrentTime().datetimeT,
      duration: '00:00:00',
      subject: '',
      instructor: '',
      remarks: '',
      print: 1,
    } as KirokuConst.Training;

    filteredTraining.push(params);

    // 新しいindex.
    const index = filteredTraining.length - 1;
    let tmp: KirokuConst.CheckData[] = [];

    // はじめてでなければ.
    if (self.state.checkDataArr) {
      tmp = self.state.checkDataArr;
    }

    tmp.push({
      id: index,
      selected: true,
    } as KirokuConst.CheckData);

    self.setState({
      checkDataArr: tmp
    });
  }
 
  export function toKiroku(self: any): void {
    self.context.callbackParent(KirokuConst.type.Show);
  }
}

export default KirokuUtil;


// WEBPACK FOOTER //
// ./src/utils/KirokuModule.tsx